(function () {
    'use strict';

	angular.module('app').factory('appGlobals', ['moduleURLs', 
        function (moduleURLs) {
            return {
				currentModule: "environment-editors",
				currentAppModule: "environment-editors",
                baseApiUrl: "api/",
                baseCommonUrX: "api/",
                basePermissionUrX: "api/",
                envUrl: moduleURLs.envUrl + '/#/main',
                sysUrl: moduleURLs.envUrl + '/#/routetosys',
                bpUrl: moduleURLs.envUrl + '/#/routetobp',
                jobUrl: moduleURLs.envUrl + '/#/routetojob',
                invUrl: moduleURLs.envUrl + '/#/routetoinv',
                orderUrl: moduleURLs.envUrl + '/#/routetoorder',
                ignoreRoute: false
            };
        }]
    );

})();
